import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=454473bc&scoped=true"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=454473bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454473bc",
  null
  
)

export default component.exports